import { render, staticRenderFns } from "./AppTable.html?vue&type=template&id=56e6f2a4&shadow"
import script from "./AppTable.js?vue&type=script&lang=js&shadow"
export * from "./AppTable.js?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./AppTable.scss?vue&type=style&index=0&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports